import { useDispatch } from 'react-redux';
import { TableHeader } from 'src/components/molecules/MOLTable/MOLTable';
import { AppDispatch } from 'src/store';
import { PromotionCoupons } from '../../models/PromotionCoupons.model';
import { setIsOpenAddDialog } from '../../slice/PromotionCouponsSlice';
import PromotionCouponsListing from './PromotionCouponsListing';
import { useFilterPagination } from 'src/hooks/useFilterPagination';
import { useFetchData } from 'src/hooks/useFetchData';
import {
  useGetPromotionCouponsQuery,
  usePromotionCouponStatusMutation,
  useDeletePromotionCouponMutation,
} from '../../service/PromotionCouponsServices';
import ATMSwitch from 'src/components/atoms/FormElements/ATMSwitch/ATMSwitch';
import { useNavigate, useParams } from 'react-router-dom';
import { showToast } from 'src/utils/showToaster';
import ShowConfirmation from 'src/utils/ShowConfirmation';
import { format } from 'date-fns';
import { formatZonedDate } from 'src/utils/formatZonedDate';

type Props = {};

const PromotionCouponsListingWrapper = (props: Props) => {
  const navigate = useNavigate();
  const [status] = usePromotionCouponStatusMutation();
  const dispatch = useDispatch<AppDispatch>();
  const { searchQuery, limit, page } = useFilterPagination();
  const { data, isLoading, totalData, totalPages } = useFetchData(
    useGetPromotionCouponsQuery,
    {
      body: {
        limit,
        page,
        searchValue: searchQuery,
        searchIn: JSON.stringify(['promotionPoint']),
      },
    },
  );
  const handleStatusChanges = (
    item: any,
    closeDialog: () => void,
    setIsLoading: any,
  ) => {
    status(item?._id).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast('success', res?.data?.message);
          closeDialog();
        } else {
          showToast('error', res?.data?.message);
        }
      }
      setIsLoading(false);
    });
  };
  const tableHeaders: TableHeader<PromotionCoupons>[] = [
    {
      fieldName: 'couponCode',
      headerName: 'Coupan Code',
      // sortKey: 'serialNumber',
      flex: 'flex-[1_0_0%]',
      renderCell(item) {
        return <div>{item?.couponCode}</div>;
      },
    },
    {
      fieldName: 'discountByPercentage',
      headerName: 'Discount By Percentage',
      // sortKey: 'serialNumber',
      flex: 'flex-[1_0_0%]',
      renderCell(item) {
        return <div>{item?.discountByPercentage}%</div>;
      },
    },
    // {
    //     fieldName: 'createdAt',
    //     headerName: 'Date',
    //     flex: 'flex-[1_1_0%]',
    //     extraClasses: () => '',
    //     stopPropagation: true,
    //     render: (row: any) => {
    //       const date = row.createdAt ? new Date(row.createdAt) : null;
    //       return date ? format(date, 'dd-MM-yyyy') : '-';
    //     },
    //   },
    {
      fieldName: 'startDate',
      headerName: 'Start Date',
      flex: 'flex-[1_1_0%]',
      extraClasses: () => '',
      stopPropagation: true,
      render: (row: any) => {
        const date = row.createdAt ? new Date(row.createdAt) : null;
        // return date ? format(date, 'dd-MM-yyyy') : '-';
        return date ? formatZonedDate(date) : '-';
      },
    },
    {
      fieldName: 'endDate',
      headerName: 'End Date',
      flex: 'flex-[1_1_0%]',
      extraClasses: () => '',
      stopPropagation: true,
      render: (row: any) => {
        const date = row.createdAt ? new Date(row.createdAt) : null;
        // return date ? format(date, 'dd-MM-yyyy') : '-';
        return date ? formatZonedDate(date) : '-';
      },
    },
    {
      fieldName: 'groupTarget',
      headerName: 'Customer Groups',
      flex: 'flex-[1_1_0%]',
      extraClasses: () => '',
      stopPropagation: true,
      render: (row: any) => {
        const groups: { itemName: string }[] = row.groupTarget || [];

        // If your stored value is just string IDs like ['golden-member'], you’ll need to map manually.
        const groupNameMap: Record<string, string> = {
          'golden-member': 'Golden Member',
          'silver-member': 'Silver Member',
          'new-user': 'New Users',
        };

        return groups.length
          ? groups.map((g: any) => groupNameMap[g._id || g] || g).join(', ')
          : '-';
      },
    },
    {
      fieldName: 'status',
      headerName: 'status',
      extraClasses: () => 'min-w-[100px]',
      flex: 'flex-[1_0_0%]',
      permissions: ['PROMOTIONCOUPONS_ACTIVE_DEACTIVE'],
      renderCell(item) {
        return (
          <div className="">
            <ATMSwitch
              checked={item?.isActive}
              onChange={(checked) => {
                ShowConfirmation({
                  type: 'INFO',
                  confirmationText: 'Yes',
                  title: 'Are you sure ?',
                  message: 'You really want to change Status',
                  onConfirm: (closeDialog, setIsLoading) =>
                    handleStatusChanges(item, closeDialog, setIsLoading),
                });
              }}
              activeLabel="Yes"
              deactiveLabel="No"
            />
          </div>
        );
      },
    },
  ];
  const [deletePromotionCoupon] = useDeletePromotionCouponMutation();
  const handleDelete = (item: any, closeDialog: () => void) => {
    deletePromotionCoupon(item?._id).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast('success', res?.data?.message);
          closeDialog();
        } else {
          showToast('error', res?.data?.message);
        }
      }
    });
  };
  return (
    <>
      <PromotionCouponsListing
        tableHeaders={tableHeaders}
        rowData={data as PromotionCoupons[]}
        onAddNew={() => dispatch(setIsOpenAddDialog(true))}
        onEdit={(item) => navigate(`/promotion-coupons/edit/${item?._id}`)}
        filterPaginationData={{
          totalCount: totalData,
          totalPages: totalPages,
        }}
        isLoading={isLoading}
        onDelete={handleDelete}
      />

      {/* {isOpenAddDialog && (
        <AddPromotionCouponsFormWrapper
          onClose={() => dispatch(setIsOpenAddDialog(false))}
        />
      )} */}
    </>
  );
};

export default PromotionCouponsListingWrapper;
